import Button from 'components/Button';
import React from 'react';
import { useFormikContext } from 'formik';

interface SubmitButtonProps {
  disableIfNoInputsTouched?: boolean;
}

export const SubmitButton: React.FC<SubmitButtonProps> = ({
  children,
  disableIfNoInputsTouched,
}) => {
  const { dirty } = useFormikContext();
  return (
    <Button type="submit" disabled={!dirty && disableIfNoInputsTouched}>
      {children}
    </Button>
  );
};

export default SubmitButton;
